import React from 'react'

import { Portlet, Row, Col, Button } from '_zari/core'

import { ZariContext } from '_zari/context'

import * as JobService from 'services/job.service'

const RecalcularCostoOperacion = () => {
  const __zariContext = React.useContext(ZariContext)

  const [iniciando, setIniciando] = React.useState(false)

  const clickRecalcular = React.useCallback(() => {
    setIniciando(true)

    JobService.iniciarJob('RECALCULAR_COSTO')
      .then(() => {
        __zariContext.snack('info', 'Recalcular costos iniciado. Se notificará cuando termine.')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => setIniciando(false))
  }, [__zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Reprocesar ultimo costo' />
      <Portlet.Body>
        <Row>
          <Col md={12} className='text-right'>
            <Button disabled={iniciando} onClick={clickRecalcular}>
              Recalcular Costos
            </Button>
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(RecalcularCostoOperacion)
